module.exports = __webpack_public_path__ + "img/clam.276342b5.svg";